export default __webpack_public_path__ + "static/media/graf-banner-why.1747f843.svg";